// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"App_layoutWrapper__1orrE","layout":"App_layout__1LipR"};